<template>
    <div id="app" :class="{ 'version-2': isVersion2 }">
        <v-layout>
            <v-game v-if="!killGame && ( $route.name === 'Landing' || $route.name === 'Explain' || $route.name === 'Game' )" v-show="$route.name === 'Explain' || $route.name === 'Game'" @reload="reloadGame" ></v-game>
            <transition mode="out-in"
                v-on:enter="getAnimateIn"
                v-on:leave="getAnimateOut"
                v-bind:css="false"
                appear>

                <router-view :key="$route.path" ref="currentView"></router-view>

            </transition>
            <!-- <img :src="'/static/img/icons/' + ( muted ? 'muted' : 'unmuted' ) + '.svg'" class="sound-toggle" @click="toggleMute()"> -->
        </v-layout>
    </div>
</template>

<style lang="scss">
    @import './static/scss/app.scss';
</style>

<script>
    import Vue from 'vue';
    import { TimelineMax } from '@/vendor';
    import { browserCheck } from '@/app/mixins';

    import Simple from '@/app/layouts/Simple';
    import Game from '@/app/components/Game';

    export default {
        name: 'app',

        components: {
            'v-layout': Simple,
            'v-game': Game
        },

        data()
        {
            return {
                muted: createjs.Sound.muted,
                killGame: false,
                preventWatcher: false
            };
        },

        computed: {
            isVersion2()
            {
                return this.$store.getters.isVersion2;
            }
        },

        watch: {
            '$route': function( pVal, pOldVal )
            {
                if( this.preventWatcher === true )
                {
                    this.preventWatcher = false;
                    return;
                }

                if( pVal.name === 'Landing' )
                {
                    this.killGame = true;
                }
                else
                {
                    this.killGame = false;
                }
            }
        },

        mixins: [ browserCheck ],

        mounted()
        {
            createjs.Sound.alternateExtensions = [ 'mp3' ];
            createjs.Sound.registerSound( '/static/sounds/jinglebells.mp3', 'music' );
            createjs.Sound.registerSound( '/static/sounds/win-synth.mp3', 'bells' );

            // createjs.Sound.volume = 0;

            if( this.browserCheck.isIE )
            {
                document.documentElement.classList.add( 'is-ie' );
            }

            document.documentElement.style.setProperty( '--vh100', window.innerHeight + 'px' ); // iphone fix voor 100vh
            window.addEventListener( 'resize', this.onResize );
            window.addEventListener( 'blur', this.muteSounds );
            window.addEventListener( 'focus', this.resumeSounds );
        },

        methods: {
            reloadGame()
            {
                this.killGame = true;
                this.preventWatcher = true;

                Vue.nextTick( () =>
                {
                    this.killGame = false;
                });
            },

            toggleMute()
            {
                this.muted = !this.muted;
                createjs.Sound.muted = this.muted;
            },

            muteSounds()
            {
                createjs.Sound.muted = true;
            },

            resumeSounds()
            {
                if( !this.muted )
                {
                    createjs.Sound.muted = false;
                }
            },

            onResize()
            {
                document.documentElement.style.setProperty( '--vh100', window.innerHeight + 'px' );
            },

            getAnimateIn( el, done )
            {
                let tl = new TimelineMax({ onComplete: done });
                if( typeof this.$refs.currentView.getAnimateIn === 'function' )
                {
                    tl.add( this.$refs.currentView.getAnimateIn(), 0 );
                }
            },

            getAnimateOut( el, done )
            {
                let tl = new TimelineMax({ onComplete: done });
                if( typeof this.$refs.currentView.getAnimateOut === 'function' )
                {
                    tl.add( this.$refs.currentView.getAnimateOut(), 0 );
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/App.vue